import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import DynamicFormModal, { ENTITY_CONFIGS } from '../../../formBuilder/wrappers/DynamicFormModal';
import { deleteCompany } from '../../../../services/clinicPortalServices/companyServices';
import Swal from 'sweetalert2';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import { trackRecentView } from '../../../../services/clinicPortalServices/recentViewService';

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            showPanel: false,
            companyId: props.data._id,
            companyName: props.data.name,
            errors: []
        };
    }

    handleShow = () => {
        this.setState({ show: true });
        // Track recent view
        const company = this.props.data;
        if (company) {
            trackRecentView('company', company._id, company.name || 'Company', '/clinic/company');
        }
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    handleDelete = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this company!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const companyInfo = {
                    id: this.state.companyId,
                    name: this.state.companyName
                };
                deleteCompany(companyInfo).then((response) => {
                    this.props.context.componentParent.loadGridData();
                });
            }
        });
    };

    renderPanel() {
        const d = this.props.data;
        const ps = { overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1040 }, panel: { position: 'fixed', top: 0, right: 0, width: '420px', height: '100vh', background: '#fff', boxShadow: '-4px 0 20px rgba(0,0,0,0.15)', zIndex: 1041, display: 'flex', flexDirection: 'column', overflowY: 'auto' }, header: { padding: '16px 20px', borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f8f9fa' }, title: { margin: 0, fontSize: '16px', fontWeight: 600, color: '#333' }, body: { padding: '20px', flex: 1 }, section: { marginBottom: '20px' }, sectionTitle: { fontSize: '11px', fontWeight: 700, color: '#888', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '10px', paddingBottom: '6px', borderBottom: '1px solid #eee' }, dl: { display: 'grid', gridTemplateColumns: '150px 1fr', rowGap: '8px', margin: 0 }, dt: { fontSize: '13px', color: '#555', fontWeight: 600, paddingRight: '8px' }, dd: { fontSize: '13px', color: '#222', margin: 0 }, editBtn: { background: '#0066cc', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px 14px', fontSize: '13px', cursor: 'pointer', marginRight: '8px' }, closeBtn: { background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#666' } };
        return ReactDOM.createPortal(
            <>
                <div style={ps.overlay} onClick={() => this.setState({ showPanel: false })} />
                <div style={ps.panel}>
                    <div style={ps.header}>
                        <h5 style={ps.title}>Company Details</h5>
                        <div>
                            <button style={ps.editBtn} onClick={() => { this.setState({ showPanel: false }); this.handleShow(); }}><i className="fas fa-pen" style={{ marginRight: 5 }}></i>Edit</button>
                            <button style={ps.closeBtn} onClick={() => this.setState({ showPanel: false })}><i className="fas fa-times"></i></button>
                        </div>
                    </div>
                    <div style={ps.body}>
                        <div style={ps.section}>
                            <div style={ps.sectionTitle}>Company Information</div>
                            <dl style={ps.dl}>
                                <dt style={ps.dt}>Company Name</dt><dd style={ps.dd}>{d.name || '—'}</dd>
                                <dt style={ps.dt}>Contact Name</dt><dd style={ps.dd}>{d.contact_name || '—'}</dd>
                                <dt style={ps.dt}>Contact Phone</dt><dd style={ps.dd}>{d.contact_mobile || '—'}</dd>
                                <dt style={ps.dt}>Contact Email</dt><dd style={ps.dd}>{d.contact_email || '—'}</dd>
                                <dt style={ps.dt}>Cost Per Order</dt><dd style={ps.dd}>{d.cost_per_order != null ? `$${d.cost_per_order}` : '—'}</dd>
                                <dt style={ps.dt}>Invoice Processing</dt><dd style={ps.dd}>{d.invoice_processing || '—'}</dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </>,
            document.body
        );
    }

    renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit Company
        </Tooltip>
    );

    renderTooltipDelete = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Delete Company
        </Tooltip>
    );

    render() {
        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">View Company</Tooltip>}>
                    <button onClick={() => this.setState({ showPanel: true })} className="edit-order-btn"><i className="fas fa-eye"></i></button>
                </OverlayTrigger>
                {this.state.showPanel && this.renderPanel()}
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipEdit}>
                    <button onClick={this.handleShow} className="edit-order-btn">
                        <i className="fas fa-pen"></i>
                    </button>
                </OverlayTrigger>
                {/* {
					!(/customerserviceuser/.test(getUserRole().toLowerCase())) &&
					<OverlayTrigger
						placement="top"
						delay={{ show: 50, hide: 100 }}
						overlay={this.renderTooltipDelete}
					>
						<button onClick={this.handleDelete} className="edit-order-btn">
							<i className="fas fa-trash"></i>
						</button>
					</OverlayTrigger>
				} */}
                <ModalStyled
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Update Company Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <DynamicFormModal
                            entityType="company"
                            entityId={this.state.companyId}
                            entityConfig={ENTITY_CONFIGS.company}
                            context={this.props.context}
                            handleClose={this.handleClose}
                        />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
